export const PhotoOcrStatusMap = {
  1: '识别成功，信息无误',
  2: '非身份证照片或检测不出身份证信息',
  3: '识别成功，但身份证号校验不通过，请确认用户证件合规性',
  4: '识别成功，但姓名不合规范，请确认用户证件合规性',
  5: '识别成功，但身份证有效期出现错误，请确认用户证件合规性',
  6: '图片下载失败，请重试',
  7: '检测异常',
};
